module.exports = __webpack_public_path__ + "static/media/stamp.cd5a6ee1.png";